import { render, staticRenderFns } from "./MasterPurchasePlanTable.vue?vue&type=template&id=62f33070&scoped=true&"
import script from "./MasterPurchasePlanTable.vue?vue&type=script&lang=js&"
export * from "./MasterPurchasePlanTable.vue?vue&type=script&lang=js&"
import style0 from "./MasterPurchasePlanTable.vue?vue&type=style&index=0&id=62f33070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f33070",
  null
  
)

export default component.exports